// extracted by mini-css-extract-plugin
export default {"childrenWrapper":"_2zNae","popper":"_3taPd","arrow":"_3hzV-","hint":"M9G2Y","popperContent":"_1ApGL","markdown":"_38O6g","hintContent":"yimUk","closeButton":"_1OEAe"};